import { AppRoute as R } from 'common/routing/app-route';


/* eslint-disable max-len, space-in-parens */
const index =     new R('/admin');
const companies = new R(`${index.path}/companies`);
/* eslint-enable */


export const Urls = {
  index,
  companies,
};
